import {
  targetGroupsByVirtualConstants,
  createTargetGroupsByVirtualConstants,
  editTargetGroupsByVirtualConstants,
  deleteTargetGroupsByVirtualConstants,
} from "../_redux-constants";

export function targetGroupsVirtualReducer(
  state = {
    targetGroupsByVirtualLoading: false,
    targetGroupsByVirtualData: null,
    targetGroupsByVirtualError: null,

    createTargetGroupsByVirtualLoading: false,
    createTargetGroupsByVirtualData: null,
    createTargetGroupsByVirtualError: null,

    editTargetGroupsByVirtualLoading: false,
    editTargetGroupsByVirtualData: null,
    editTargetGroupsByVirtualError: null,

    deleteTargetGroupsByVirtualLoading: false,
    deleteTargetGroupsByVirtualData: null,
    deleteTargetGroupsByVirtualError: null,
  },
  action
) {
  switch (action.type) {
    case targetGroupsByVirtualConstants.TARGET_GROUPS_BY_VIRTUAL_LOADING:
      return Object.assign({}, state, {
        targetGroupsByVirtualLoading: true,
        targetGroupsByVirtualData: null,
        targetGroupsByVirtualError: null,
      });
    case targetGroupsByVirtualConstants.TARGET_GROUPS_BY_VIRTUAL_SUCCESS:
      return Object.assign({}, state, {
        targetGroupsByVirtualLoading: false,
        targetGroupsByVirtualData: action.data,
      });
    case targetGroupsByVirtualConstants.TARGET_GROUPS_BY_VIRTUAL_FAILURE:
      return Object.assign({}, state, {
        targetGroupsByVirtualLoading: false,
        targetGroupsByVirtualData: null,
        targetGroupsByVirtualError: action.error,
      });
    case createTargetGroupsByVirtualConstants.CREATE_TARGET_GROUPS_BY_VIRTUAL_LOADING:
      return Object.assign({}, state, {
        createTargetGroupsByVirtualLoading: true,
        createTargetGroupsByVirtualData: null,
        createTargetGroupsByVirtualError: null,
      });
    case createTargetGroupsByVirtualConstants.CREATE_TARGET_GROUPS_BY_VIRTUAL_SUCCESS:
      return Object.assign({}, state, {
        createTargetGroupsByVirtualLoading: false,
        createTargetGroupsByVirtualData: action.data,
      });
    case createTargetGroupsByVirtualConstants.CREATE_TARGET_GROUPS_BY_VIRTUAL_FAILURE:
      return Object.assign({}, state, {
        createTargetGroupsByVirtualLoading: false,
        createTargetGroupsByVirtualData: null,
        createTargetGroupsByVirtualError: action.error,
      });
    case editTargetGroupsByVirtualConstants.EDIT_TARGET_GROUPS_BY_VIRTUAL_LOADING:
      return Object.assign({}, state, {
        editTargetGroupsByVirtualLoading: true,
        editTargetGroupsByVirtualData: null,
        editTargetGroupsByVirtualError: null,
      });
    case editTargetGroupsByVirtualConstants.EDIT_TARGET_GROUPS_BY_VIRTUAL_SUCCESS:
      return Object.assign({}, state, {
        editTargetGroupsByVirtualLoading: false,
        editTargetGroupsByVirtualData: action.data,
      });
    case editTargetGroupsByVirtualConstants.EDIT_TARGET_GROUPS_BY_VIRTUAL_FAILURE:
      return Object.assign({}, state, {
        editTargetGroupsByVirtualLoading: false,
        editTargetGroupsByVirtualData: null,
        editTargetGroupsByVirtualError: action.error,
      });

    case deleteTargetGroupsByVirtualConstants.DELETE_TARGET_GROUPS_BY_VIRTUAL_LOADING:
      return Object.assign({}, state, {
        deleteTargetGroupsByVirtualLoading: true,
        deleteTargetGroupsByVirtualData: null,
        deleteTargetGroupsByVirtualError: null,
      });
    case deleteTargetGroupsByVirtualConstants.DELETE_TARGET_GROUPS_BY_VIRTUAL_SUCCESS:
      return Object.assign({}, state, {
        deleteTargetGroupsByVirtualLoading: false,
        deleteTargetGroupsByVirtualData: action.data,
      });
    case deleteTargetGroupsByVirtualConstants.DELETE_TARGET_GROUPS_BY_VIRTUAL_FAILURE:
      return Object.assign({}, state, {
        deleteTargetGroupsByVirtualLoading: false,
        deleteTargetGroupsByVirtualData: null,
        deleteTargetGroupsByVirtualError: action.error,
      });
    default:
      return state;
  }
}
